import { Invoices } from '../../services';
import { createRestSlices, createGenericSlice, applyReducers } from './rest';

const {
    initialState,
    createReducer,
    startCreateReducer,
    getReducer,
    listReducer,
    updateReducer,
    deleteReducer,
    startCreateAction: startCreateInvoice,
    createAction: createInvoice,
    getAction: loadInvoice,
    listAction: loadInvoices,
    updateAction: updateInvoice,
    deleteAction: deleteInvoice,
} = createRestSlices(Invoices);

const { reducer: generateReducer, action: generateInvoices } = createGenericSlice(Invoices, {
    // name can be what you want without spaces
    name: 'generateInvoices',
    // name can be a Service method and must return a Promise
    action: () => Invoices.generate(),
    // on success reducer step
    onSuccess: (state, action) => ({
        ...state,
        invoicesSuccessfullyGenerated: true,
        invoices: action.invoices
    }),
    // on error reducer step
    onError: (state, error) => ({
        ...state,
        invoicesSuccessfullyGenerated: false,
        generated: null
    }),
});

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        generateReducer
    ]);
}

/* Export CRUD actions */
export {
    startCreateInvoice, createInvoice,
    loadInvoice, loadInvoices,
    updateInvoice, deleteInvoice,
    generateInvoices,
};
